// extracted by mini-css-extract-plugin
export default {"content":"BiorhythmsReportsPage_content__tcF8T","btnsContainer":"BiorhythmsReportsPage_btnsContainer__Ot1IL","radarContainer":"BiorhythmsReportsPage_radarContainer__oQlnL"};